
import React from 'react';
import Header from '../../components/feature/Header';
import VideoSlider from '../../components/feature/VideoSlider';
import Footer from '../../components/feature/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <VideoSlider />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
